﻿window.cBuilderEmailWidgetMenu = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetmenu'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Menu</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un menu")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetmenu'>")
        $("<!-- DEBUT MENU -->").appendTo(option.element)
        var $Td = $("<td style='width:100%;' width='100%' class='tdwidget bodywidget widgetheightauto' widthmenu='120' espacement='15'>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("menu")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        mGenereTableauMenu([lstMenu[0], lstMenu[1], lstMenu[2]], $Td)

        $("<!-- FIN MENU -->").appendTo(option.element)
    }

    function mGenereTableauMenu(lstEleData, contentElement) {
        var widthLeft = "50%"
        var widthRight = "50%"
        switch (option.parent.mGetTextAlignCss()) {
            case "left":
                widthLeft = "0"
                widthRight = "100%"
                break;
            case "center": break;
            case "right":
                widthLeft = "100%"
                widthRight = "0"
                break;
        }

        if (typeof contentElement == 'undefined') contentElement = option.parent.mGetBodyWidget()
        contentElement.empty()
        var $Table = $("<table border='0' cellspacing='0' cellpadding='0' style='width:100%' class='tablewidget tablelstmenu'>").appendTo(contentElement)
        var $TrTableBt = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:" + widthLeft + "'></td>").appendTo($TrTableBt)
        lstEleData.forEach(function (data) { mGenereTdMenu(data, contentElement).appendTo($TrTableBt) })
        var $Td = $("<td style='width:" + widthRight + "'></td>").appendTo($TrTableBt)
    }
    function mGenereTdMenu(dataMenu, contentElement) {
        if (typeof contentElement == 'undefined') contentElement = option.parent.mGetBodyWidget()
        var padding = "padding:0 " + contentElement.attr("espacement") + "px;"
        var widthmenu = contentElement.attr("widthmenu")
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var styleBorder = ""
        if (jsonCssData["border-width"].length > 0) styleBorder += "border-left-width:" + jsonCssData["border-width"] + ";border-right-width:" + jsonCssData["border-width"] + ";"
        if (jsonCssData["border-style"].length > 0) styleBorder += "border-left-style:" + jsonCssData["border-style"] + ";border-right-style:" + jsonCssData["border-style"] + ";"
        if (jsonCssData["border-color"].length > 0) styleBorder += "border-left-color:" + jsonCssData["border-color"] + ";border-right-color:" + jsonCssData["border-color"] + ";"
        var $TdMaitre = $("<td style='word-break:keep-all;width " + widthmenu + "px;" + padding + "text-align:center;" + styleBorder + "' class='itemmenu''/>")
        var $A = $("<a href='" + dataMenu.url + "' target='_blank' class='menu_a'>" + dataMenu.nom + "</a>").appendTo($TdMaitre)
        return $TdMaitre
    }

    function mGetLstElement() {
        var lst = []
        option.parent.mGetBodyWidget().find(".itemmenu").each(function (idx, ele) {
            lst.push({
                url: $($(ele).find("a")[0]).attr("href"),
                nom: $($(ele).find("a")[0]).text(),
                element: $(ele)
            })
        })
        return lst
    }

    function mGetTdLeft() { return $(option.element.find(".tdleft")[0]) }

    this.nom = "Menu"
    this.icone = "fas fa-bars"

    var lstMenu = [
        { url: parametre.url_site_vitrine, nom: "Menu1" },
        { url: parametre.url_site_vitrine, nom: "Menu2" },
        { url: parametre.url_site_vitrine, nom: "Menu3" },
        { url: parametre.url_site_vitrine, nom: "Menu4" },
        { url: parametre.url_site_vitrine, nom: "Menu5" },
    ]

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
        $("<br/>").appendTo(contentElement)

        var lstElement = mGetLstElement()
        var $Table = $("<table/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Menu</td>").appendTo($Tr)
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-plus",
            onClick: function (e) {
                lstElement.push({
                    url: parametre.url_site_vitrine,
                    nom: "Menu"
                })
                mGenereTableauMenu(lstElement)
                option.onValueChanged()
                dxList.reload()
            }
        })
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-certificate",
            onClick: function (e) {
                lstElement.push({
                    url: parametre.url_site_vitrine,
                    nom: "Menu"
                })
                mGenereTableauMenu(lstElement)
                option.onValueChanged()
                dxList.reload()
            }
        })

        var dxList = $("<div/>").appendTo(contentElement).dxList({
            dataSource: lstElement,
            itemDragging: {
                allowReordering: true
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding-right", "3px")
                itemElement.css("padding-left", "3px")
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom du menu",
                    value: itemData.nom,
                    onValueChanged: function (e) {
                        itemData.nom = ((e.value == null) ? "" : e.value)
                        itemData.element.find("a").text(itemData.nom)
                        option.onValueChanged()
                    }
                })
                $("<div/>").appendTo($Td).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Url du menu",
                    value: itemData.url,
                    onValueChanged: function (e) {
                        itemData.url = ((e.value == null) ? "" : e.value)
                        itemData.element.find("a").attr("href", itemData.url)
                        option.onValueChanged()
                    }
                })
                var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    onClick: function (e) {
                        lstElement.splice(lstElement.indexOf(itemData.element), 1)
                        mGenereTableauMenu(lstElement)
                        option.onValueChanged()
                        dxList.reload()
                    }
                })
            },
            onItemReordered: function (e) {
                lstElement.move(e.fromIndex, e.toIndex)
                mGenereTableauMenu(lstElement)
                option.onValueChanged()
            }
        }).dxList("instance")

        $("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:100%;font-weight:bold;' class=''>Taille:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlRadioButton({
            dataSource: ["Petit", "Moyen", "Grand", "..."],
            value: ((option.parent.mGetBodyWidget().attr("widthmenu") == 60) ? "Petit" : ((option.parent.mGetBodyWidget().attr("widthmenu") == 120) ? "Moyen" : ((option.parent.mGetBodyWidget().attr("widthmenu") == 180) ? "Grand" : "..."))),
            layout: 'horizontal',
            onValueChanged: function (e) {
                $DivTaille.css("display", "none")
                switch (e.value) {
                    case "Petit":
                        option.parent.mGetBodyWidget().attr("widthmenu", "60")
                        dxLargeur.option("value", 60)
                        break;
                    case "Moyen":
                        option.parent.mGetBodyWidget().attr("widthmenu", "120")
                        dxLargeur.option("value", 120)
                        break;
                    case "Grand":
                        option.parent.mGetBodyWidget().attr("widthmenu", "180")
                        dxLargeur.option("value", 180)
                        break;
                    case "...":
                        $DivTaille.css("display", "");
                        dxLargeur.repaint()
                        break;
                }
                option.onValueChanged()
            }
        })
        var $DivTaille = $("<div style=''/>").appendTo(contentElement)
        switch (option.parent.mGetBodyWidget().attr("widthmenu")) {
            case "60": case "120": case "180":
                $DivTaille.hide()
                break;
            default:
                break;
        }
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Taille Menu</div>").appendTo($DivTaille)
        var dxLargeur = $("<div/>").appendTo($DivTaille).dxSlider({
            min: 12,
            max: 400,
            value: parseInt(option.parent.mGetBodyWidget().attr("widthmenu")),
            onValueChanged: function (e) {
                option.parent.mGetBodyWidget().attr("widthmenu", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            }
        }).dxSlider("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Espacement:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxSlider({
            min: 0,
            max: 100,
            value: option.parent.mGetBodyWidget().attr("espacement"),
            onValueChanged: function (e) {
                option.parent.mGetBodyWidget().attr("espacement", e.value)
                option.onValueChanged()
            },
            tooltip: {
                enabled: true,
                format(value) {
                    return `${value}px`;
                },
                showMode: 'always',
                position: 'bottom',
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.repaint() }, 0)
            }
        }).dxSlider("instance")

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Ligne séparateur:</div>").appendTo(contentElement)
        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("menu")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: false,
            borderWidth: jsonCssData["border-width"],
            borderStyle: jsonCssData["border-style"],
            borderColor: jsonCssData["border-color"],
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.onValueChanged()
            }
        })
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("menu")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du menu:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("p")) {
            if (prop == "border-width" || prop == "border-style" || prop == "border-color") {
                //ignore
            } else {
                if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                    option.parent.mGetBodyWidget().css(prop, jsonCssData[prop])
                } else {
                    option.parent.mGetBodyWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("p", prop))
                }
            }
        }
        mGenereTableauMenu(mGetLstElement())
    }

}